<script lang="ts">
import AvatarGroup from '@/components/avatars/AvatarGroup.svelte'
import { testIds } from '@/constants'
import { closeMessengerFrame } from '@/modules/app'
import { isFullScreenEnabled, isTouchDevice } from '@/modules/device'
import { messengerHeaderHeight, px } from '@/modules/frames'
import { widgetOptions } from '@/modules/options'

import HeaderBasicButtons from './WidgetHeaderBasicButtons.svelte'
import HeaderButtons from './WidgetHeaderButtons.svelte'
import HeaderStatusText from './WidgetHeaderStatusText.svelte'
import HeaderTitleText from './WidgetHeaderTitleText.svelte'

const { widgetBlockingOptions: disableCloseButton } = widgetOptions.getOptions()

const closeMessenger = () => {
	if (!disableCloseButton) closeMessengerFrame()
}
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
	role="menubar"
	tabindex="0"
	class={[
		'flex flex-col shrink-0 w-full bg-primary-gradient text-primary-content shadow-md z-1',
		!isTouchDevice() && !disableCloseButton && 'cursor-pointer',
		$isFullScreenEnabled && 'px-2 justify-center',
	]}
	style:height={px($messengerHeaderHeight)}
	data-testid={testIds.widgetHeader}
	onclick={closeMessenger}
>
	{#if !$isFullScreenEnabled}
		<HeaderButtons />
	{/if}
	<div class={`flex ${$isFullScreenEnabled ? 'h-68px items-center py-1 h-full' : 'h-64px mx-4 pb-3 pt-2'}`}>
		<AvatarGroup size="lg" />
		<div class={['flex flex-1 flex-col justify-center min-w-0', $isFullScreenEnabled ? 'ml-2' : 'ml-3']}>
			<HeaderTitleText />
			<HeaderStatusText />
		</div>
		{#if $isFullScreenEnabled}
			<HeaderBasicButtons />
		{/if}
	</div>
</div>
